export const MAX_DRAGGABLE_WINDOW_WIDTH_PX = 768;
